import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default class AvailableIntegrationsCard extends React.Component {

  static propTypes = {
    children: PropTypes.object.isRequired,
    currentDatabase: PropTypes.object.isRequired,
    databases: PropTypes.array.isRequired,
    image: PropTypes.string.isRequired,
    integration: PropTypes.object,
    toolTipId: PropTypes.string.isRequired,
    onConnect: PropTypes.func.isRequired,
  };

  render() {
    const { children, image } = this.props;

    return (
      <React.Fragment>
        <hr className="ml-0 mr-0 mt-3 mb-3"/>
        <div className="d-flex">
          <div className="col-xs-1">
            <img className="img-thumbnail" src={image}/>
          </div>
          {children}
          {this.renderConnectionButton()}
        </div>
      </React.Fragment>
    );
  }

  renderConnectionButton() {
    const { currentDatabase, integration, databases, toolTipId, onConnect } = this.props;
    const databaseId = integration ? integration.databaseId : null;
    const connectedDatabase = databases.find(t => t.id === databaseId);

    if (databaseId) {
      let message;

      if (connectedDatabase && currentDatabase.id === databaseId) return;

      if (connectedDatabase) {
        message = `
          You currently have this integration synced with ${connectedDatabase.name}. Disconnect from that
          database if you wish to connect to ${currentDatabase.name}
        `;
      } else {
        message = `
          You currently have this integration synced with ${integration.databaseName} an inactive database.
          Disconnect from that database if you wish to connect to ${currentDatabase.name}
        `;
      }

      const connectedToolTip = (
        <Tooltip id={toolTipId} placement="top">
          <span>{message}</span>
        </Tooltip>
      );

      return (
        <div className="col-xs-3 mt-3">
          <OverlayTrigger overlay={connectedToolTip} placement="top">
            <button className="connection-btn btn btn-sm btn-dark disabled-btn">
              <FontAwesomeIcon icon={faPlus}/>
              <span className="pl-2">Connect</span>
            </button>
          </OverlayTrigger>
        </div>
      );
    } else {
      return (
        <div className="col-xs-3 mt-3">
          <button className="connection-btn btn btn-sm btn-dark clickable" onClick={onConnect}>
            <FontAwesomeIcon icon={faPlus}/>
            <span className="pl-2">Connect</span>
          </button>
        </div>
      );
    }
  }
}
